export default __webpack_public_path__ + "static/media/mobile_apiary_map.575077ad.png";